import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { RecentProjectItem } from "@/types";

type Params = {
  account_id: string;
  role: string;
};

export function useRecentProject(params: Params) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["recent-projects", params],
    queryFn: () => apiFetch<RecentProjectItem[]>(`/v1/home/recent-projects${query}`),
    enabled: true, // TODO: remove when API is ready
  });
}
